<template>
  <div>
    <div class="card card-info">
      <div class="card-header">
        <h3 class="card-title">Manage</h3>
      </div>
      <form v-on:submit="save">
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Semester *</label>
                <select required class="form-control" v-model="test.ActiveSemesterID" v-on:change="loadOfferedPrograms()" id="ddlSession">
                  <option value="0" selected="selected" disabled="disabled">--Select Semester--</option>
                  <option v-for="item in semesters" v-bind:value="item.SemesterID">{{item.Name}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Degree *</label>
                <select required class="form-control" v-on:change="loadOfferedPrograms()" v-model="test.DegreeID">
                  <option value="0" selected="selected" disabled="disabled">--Select Degree--</option>
                  <option v-for="item in degrees" v-bind:value="item.DegreeID">{{item.Name}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>
                  Program *
                </label>
                <label style="float: right" v-if="programs.length > 0" class="customlable">
                  <input v-model="selectAllProgram" v-on:change="selectAllProgramChange()" type="checkbox">
                  <span>Select All</span>
                </label>
                <v-select id="sel" v-bind:options="programs" v-model="selectedPrograms" label="ProgramName" v-bind:multiple="true" />
              </div>
            </div>

            <div class="col-lg-6 col-md-12">
              <div class="form-group">
                <div class="form-group">
                  <label>Test Name *</label>
                  <input class="form-control" v-model="test.Name" maxlength="60" />
                </div>
              </div>
            </div>

            <div class="col-lg-2 col-md-4">
              <div class="form-group">
                <label>Date *</label>
                <input type="date" class="form-control pull-right" id="date">
                <!-- /.input group -->
              </div>
            </div>

            <div class="col-lg-2 col-md-4">
              <div class="form-group">
                <label>Start Time *</label>
                <input type="time" class="form-control" id="time">
                <!-- /.input group -->
              </div>
            </div>

            <div class="col-lg-2 col-md-4" v-if="test.isonline != 'false' && test.isonline != false">
              <div class="form-group">
                <label>End Time *</label>
                <input type="time" class="form-control" id="endtime" v-model="test.EndTime">
                <!-- /.input group -->
              </div>
            </div>

            <div class="col-lg-2 col-md-4" v-if="test.isonline == 'false' || test.isonline == false">
              <div class="form-group">
                <label>Total Marks </label>
                <input type="tel" class="form-control pull-right" v-mask="'###'" v-model="totalmarks">
              </div>
            </div>

            <div class="col-md-12" v-if="test.isonline == 'false' || test.isonline == false">
              <div class="form-group">
                <label>Examination Halls *</label>
                <label style="float: right" v-if="halls.length > 0" class="customlable">
                  <input v-model="selectAllHall" v-on:change="selectAllHallChange()" type="checkbox">
                  <span>Select All</span>
                </label>
              </div>
            </div>

            <div v-if="test.isonline == 'false' || test.isonline == false" class="col-lg-3 col-md-4 col-sm-6 col-xs-12" v-for="(item, index) in halls">
              <label class="customlable">
                <input v-model="item.Active" type="checkbox">
                <span>{{item.Name}} - Seats({{item.SeatingCapacity}})</span>
              </label>
            </div>

            <div class="col-md-12 ">
              <button class="btn btn-success pull-right " type="button" v-on:click="loadCandidates()">load Candidates</button>
              <hr />
            </div>
          </div>
          <div class="row" v-show="candidates.length > 0">
            <div class="col-md-12">
              <label>Student List</label>
              <div style="max-height: 700px; overflow-y: scroll">
                <table id="example2" class="table table-bordered table-sm">
                  <thead class="bg-info">
                    <tr>
                      <th>Sr.</th>
                      <th style="width: 15%; text-align: center">Form No</th>
                      <th style="width: 25%;">Name</th>
                      <th style="width: 25%;">Father Name</th>
                      <th style="width: 15%;">Hall</th>
                      <th style="width: 10%; text-align: center">Row</th>
                      <th style="width: 10%; text-align: center">Seat</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in candidates">
                      <td style="text-align: center">{{index + 1}}</td>
                      <td style="width: 15%; text-align: center">{{item.FormNo}}</td>
                      <td style="width: 25%;">{{item.Name}}</td>
                      <td style="width: 25%;">{{item.FatherName}}</td>
                      <td style="width: 15%;">{{item.HallName}}</td>
                      <td style="width: 10%; text-align: center">{{item.RowName}}</td>
                      <td style="width: 10%; text-align: center">{{item.SeatNo}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <a class="btn btn-primary" href="../Admission/EntryTestList ">Back to List</a>
          <input type="submit" value="Save" class="btn btn-success float-right" />
        </div>
      </form>
    </div>

    
  </div>
   
</template>

<script>

  const axios = require('axios').default;

  export default ({

    data() {
      return {
        id: 0,
        isupdate: false,
        programs: [],
        degrees: [],
        semesters: [],
        selecteddeptid: 0,
        halls: [],
        test: { Name: '', ProgramID: 0, SessionID: 0, DegreeID: 0, ActiveSemesterID: 0, isonline: false, EntryTestID: '' },
        candidates: [],
        totalmarks: 100,
        programId: [],
        selectedPrograms: [],
        selectAllProgram: false,
        selectAllHall: false,

        hallsForEmail: [],
      }
    },

    created: function () {
    },

    mounted: function () {
      this.pageLoad();
    },

    updated: function () {
    },

    methods:
    {
      pageLoad: function () {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams) {
          this.id = Number(urlParams.get('id'));
          var uri = window.location.toString();
          if (uri.indexOf("?") > 0) {
            var clean_uri = uri.substring(0, uri.indexOf("?"));
            window.history.replaceState({}, document.title, clean_uri);
          }
        }
        var vm = this;
        startReq();

        axios.post('/api/AdmissionApi/pageLoadEntryTestCreate?id=' + vm.id)
          .then(function (pl) {
            endReq();
            vm.semesters = pl.data["sem"];
            vm.degrees = pl.data["deg"];
            vm.halls = pl.data.halls;
            if (pl.data.test) {
              vm.programs = pl.data.offeredPrograms;
              $('#date').val(pl.data.test.Date);
              $('#time').val(pl.data.test.time);
              vm.isupdate = true;
              vm.totalmarks = pl.data["totalmarks"];
              vm.test = pl.data.test;
              vm.candidates = pl.data["candidates"];

              var dd = pl.data["prog"];
              //vm.selectedPrograms = vm.programs.find(x => x.ProgramID == dd[0].ProgramID);
              for (var i = 0; i < dd.length; i++) {
                var ddd = vm.programs.find(x => x.ProgramID == dd[i].ProgramID);
                vm.selectedPrograms.push(ddd);
              }
            }
          })
      },

      loadOfferedPrograms: function () {
        if (this.test.ActiveSemesterID && this.test.DegreeID) {
          var vm = this;
          startReq();
          axios.post('/api/AdmissionApi/loadOfferedPrograms?semID=' + vm.test.ActiveSemesterID + '&degID=' + vm.test.DegreeID )
            .then(function (pl) {
              endReq();
              vm.programs = pl.data;
            })
        }
      },
       

      loadCandidates() {
        if (this.selectedPrograms.length > 0) {
          //if (this.selectedPrograms) {
          var vm = this;
          startReq();
          vm.programId = []
          for (var i = 0; i < vm.selectedPrograms.length; i++) {
            vm.programId.push(vm.selectedPrograms[i].ProgramID);
          }

          //vm.programId.push(vm.selectedPrograms.ProgramID);


          axios.post('/api/AdmissionApi/loadAllCandidatesEntryTest', {
            halls: vm.halls,
            entryTestID: vm.test.EntryTestID,
            semesterID: vm.test.ActiveSemesterID,
            pro: vm.programId
          })
            .then(function (res) {
              endReq();
              vm.candidates = res.data;
            })
            .catch(function (res) {
              endReq();

            });
        }
        else {
          toastr.error("Program is required");
        }
      },

      loadHalls() {
        var vm = this;
        axios.post('/api.asmx/loadHalls')
          .then(function (res) {
            vm.halls = res.data;
          })
          .catch(function (res) {

          });
      },

      save(e) {

        e.preventDefault();

        var vm = this;

        if ($('#date').val() === "") {
          toastr.error("Date is required", "Error!");
          return;
        }
        else if ($('#time').val() === "") {
          toastr.error("Start Time is required", "Error!");
          return;
        }
        else if (vm.test.Name === "") {
          toastr.error("Test Name is required", "Error!");
          return;
        }
        else if ((vm.test.isonline == 'true' || vm.test.isonline == 'True') && !vm.test.EndTime) {
          toastr.error("End Time is required", "Error!");
          return;
        }
        else if (vm.totalmarks === "") {
          toastr.error("Total marks is required", "Error!");
          return;
        }

        startReq();

        if (!vm.isupdate) {
          axios.post('/api/AdmissionApi/newEntryTest', {
            pro: vm.programId,
            candidates: vm.candidates,
            test: vm.test,
            datetime: $('#date').val() + " " + $('#time').val(),
            totalmarks: vm.totalmarks,
          })
            .then(function (res) {
              endReq();
              var rs = res.data;
              if (!rs.status) {
                var error = rs.error;
                for (var i = 0; i < error.length; i++) {
                  toastr.error(error[i] + " is required", "Error!");
                }
              }
              else if (rs.status) {
                toastr.success("Saved successfully", "Done!");
                vm.reset();
              }
              else {
                console.log(res.data);
              }
            })
            .catch(function (res) {
              console.log(res.data);
            });
        }
        else {
          vm.programId = [];
          for (var i = 0; i < vm.selectedPrograms.length; i++) {
            vm.programId.push(vm.selectedPrograms[i].ProgramID);
          }

          //vm.programId.push(vm.selectedPrograms.ProgramID);

          startReq();
          axios.post('/api/AdmissionApi/updateEntryTest', {
            candidates: vm.candidates,
            test: vm.test,
            pro: vm.programId,
            datetime: $('#date').val() + " " + $('#time').val(),
            totalmarks: vm.totalmarks
          })
            .then(function (res) {
              endReq();
              var rs = res.data;
              if (rs.status === "incomplete") {
                var error = rs.error;
                for (var i = 0; i < error.length; i++) {
                  toastr.error(error[i] + " is required", "Error!");
                }
              }
              else if (rs.status === "success") {
                toastr.success("Saved successfully", "Done!");
                window.location.href = "../Admission/EntryTestList";
              }
              else {
                toastr.error("Access Denied", "Error!");
                console.log(res.data);
              }
            })
            .catch(function (res) {
              console.log(res.data);
            });
        }

      },

      Date() {

        for (var i = 0; i < this.programs.length; i++) {

          if (this.programs[i].InsertionDate === "") {
            var pattern = /Date\(([^)]+)\)/;

            var results = pattern.exec(this.programs[i].InsertionDate);

            var dt = new Date(parseFloat(results[1]));
            this.programs[i].InsertionDate = dt.getDate() + "-" + this.months[dt.getMonth()] + "-" + dt.getFullYear();
            // alert(this.programs[i].InsertionDate)
          }
          if (this.programs[i].UpdatedDate === "") {

            this.programs[i].InsertionDate = dt.getDate() + "-" + this.months[dt.getMonth()] + "-" + dt.getFullYear();
            var pattern = /Date\(([^)]+)\)/;

            var results = pattern.exec(this.programs[i].UpdatedDate);

            var dt = new Date(parseFloat(results[1]));

            this.programs[i].UpdatedDate = dt.getDate() + "-" + this.months[dt.getMonth()] + "-" + dt.getFullYear();
          }
        }
      },

      reset() {
        this.isupdate = false;
        this.programs = [];
        this.sessions = [];
        this.selecteddeptid = 0;
        this.halls = [];
        this.test.Name = '';
        this.test.ProgramID = 0;
        this.test.SessionID = 0;
        this.candidates = [];
        $('#date').val();
        $('#time').val();
        this.programId = [];
        this.selectedPrograms = [];
        this.selectAllProgram = false;
        this.selectAllHall = false;
      },

      selectAllProgramChange() {
        var vm = this;
        vm.selectedPrograms = [];
        if (vm.selectAllProgram) {
          vm.programs.forEach(function (item) {
            vm.selectedPrograms.push(item);
          });
        }
      },

      selectAllHallChange() {
        var vm = this;
        vm.halls.forEach(function (item) {
          item.Active = vm.selectAllHall;
        });
      }
    }
  })</script>

<style>
  .h4-t {
    margin-top: -9px;
    margin-bottom: -5px;
    font-weight: 600
  }

  .h4-c {
    margin-bottom: -5px;
    font-weight: 600
  }
</style>





// WEBPACK FOOTER //
// src/components/onlineadmission/entryTestCreate.vue